import { Component, EventEmitter, OnDestroy, OnInit, Output, Input, ViewChild } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { BsModalRef } from "ngx-bootstrap";
import { ApiService, PaymentRecordDTO } from "../../../../../../projects/accounting/src/public_api";

export interface DepositsEditorData {

  capitalId: number;
  name: string;
  address: string;
  period: string;
  total: number;
}

@Component({
  selector: 'deposits-editor',
  templateUrl: './deposits-editor.component.html',
  styleUrls: ['./deposits-editor.component.scss']
})
export class DepositsEditorComponent implements OnInit, OnDestroy {

  @Input() data: DepositsEditorData = null;
  @Output() closed = new EventEmitter();

  records: Array<PaymentRecordDTO> = [];

  message = '';

  loading = false;
  changed = false;

  constructor(
    public modalRef: BsModalRef,
    private api: ApiService,
    private decimal: DecimalPipe,
  ) {
  }

  ngOnInit() {

    this.loading = true;

    this.api.depositOfOutlet(this.data.capitalId).subscribe(response => {
      if (response.succeed) {

        this.records = response.data;
      }
      this.loading = false;
    })
  }

  ngOnDestroy(): void {
      this.closed.emit(this.changed);
  }

  getDate(record: PaymentRecordDTO) {
    return record.Notes.split(' ')[0];
  }

  convert(record: PaymentRecordDTO) {
    this.loading = true;

    this.api.depositToDebt({ ID: record.ID, Period: this.data.period }).subscribe(response => {
      if (response.succeed && response.data) {
        this.changed = true;
        this.data.total -= record.Amount;
        this.records = this.records.filter(i => i != record);
      }

      this.loading = false;
    });
  }
}
